import { useSelector } from "react-redux";
import { RootState } from "../../utils/store";
import Loader from "./Loader";

const RehydrationGuard = ({ children }: { children: React.ReactNode }) => {
    const { isRehydrated } = useSelector((state: RootState) => state.auth);

    if (!isRehydrated) {
        return <Loader />;
    }

    return <>{children}</>;
};

export default RehydrationGuard;
